// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import {
    getTypesContacts as listTypesContactsAPI,
    getTypesContact as getTypeContactAPI,
    addTypesContact as addTypeContactAPI,
    updateTypesContact as updateTypeContactAPI,
    deleteTypesContact as deleteTypeContactAPI,
} from '../../helpers/';

import { typesContactsApiResponseError, typesContactsApiResponseSuccess } from './actions';
import { TypesContactsActionTypes } from './constants';

function* getTypesContact({ payload: { id } }) {
    try {
        const response = yield call(getTypeContactAPI, id );
        const typeContactItem = response.data.data;
        yield put(typesContactsApiResponseSuccess(TypesContactsActionTypes.GET_TYPES_CONTACTS, typeContactItem));
    } catch (error) {
        yield put(typesContactsApiResponseError(TypesContactsActionTypes.GET_TYPES_CONTACTS, error));
    }
}

function* addTypesContact({payload:typeContact}){
    try{
        const response = yield call(addTypeContactAPI,{...typeContact})
        const typeContactItem = response.data
        yield put(typesContactsApiResponseSuccess(TypesContactsActionTypes.ADD_TYPES_CONTACTS,typeContactItem))
    } catch(error){
        yield put(typesContactsApiResponseError(TypesContactsActionTypes.ADD_TYPES_CONTACTS,error))
    }
}

function* updateTypesContact({payload:typeContact}){
    try{
        const response = yield call(updateTypeContactAPI,{...typeContact})
        const typeContactItem = response.data.data
        yield put(typesContactsApiResponseSuccess(TypesContactsActionTypes.UPDATE_TYPES_CONTACTS,typeContactItem))
    }catch(error){
        yield put(typesContactsApiResponseError(TypesContactsActionTypes.UPDATE_TYPES_CONTACTS,error))
    }
}
function* deleteTypesContact({payload:{id}}){
    try{
        const response = yield call(deleteTypeContactAPI,id)
        const typeContactItem = response.data.id
        yield put(typesContactsApiResponseSuccess(TypesContactsActionTypes.DELETE_TYPES_CONTACTS,typeContactItem))
    }catch(error){
        yield put(typesContactsApiResponseError(TypesContactsActionTypes.DELETE_TYPES_CONTACTS,error))
    }
}

/**
 * List contactos
 */
function* listTypesContacts({payload:params}) {
    try {
        const response = yield call(listTypesContactsAPI, { ...params });
        const listaTypesContacts = response.data.data;
        yield put(typesContactsApiResponseSuccess(TypesContactsActionTypes.LIST_TYPES_CONTACTS, listaTypesContacts));
    } catch (error) {
        yield put(typesContactsApiResponseError(TypesContactsActionTypes.LIST_TYPES_CONTACTS, error));
    }
}


export function* watchGetTypesContact(): any {
    yield takeEvery(TypesContactsActionTypes.GET_TYPES_CONTACTS, getTypesContact);
}

export function* watchListTypesContacts(): any {
    yield takeEvery(TypesContactsActionTypes.LIST_TYPES_CONTACTS, listTypesContacts);
}

export function* watchAddTypesContact():any{
    yield takeEvery(TypesContactsActionTypes.ADD_TYPES_CONTACTS, addTypesContact)
}
export function* watchUpdateTypesContact():any{
    yield takeEvery(TypesContactsActionTypes.UPDATE_TYPES_CONTACTS, updateTypesContact)
}
export function* watchDeleteTypesContact():any{
    yield takeEvery(TypesContactsActionTypes.DELETE_TYPES_CONTACTS, deleteTypesContact)
}


function* typesContactsSaga(): any {
    yield all([
        fork(watchGetTypesContact),
        fork(watchListTypesContacts),
        fork(watchAddTypesContact),
        fork(watchUpdateTypesContact),
        fork(watchDeleteTypesContact),
    ]);
}

export default typesContactsSaga;
